import { render } from "./Forward.vue?vue&type=template&id=229e09f9"
import script from "./Forward.vue?vue&type=script&lang=js"
export * from "./Forward.vue?vue&type=script&lang=js"
script.render = render

export default script